var map = {
	"./Amazon.png": 235,
	"./Apple.png": 236,
	"./Facebook.png": 237,
	"./Google.png": 238,
	"./Microsoft.png": 239,
	"./No Company.png": 240,
	"./Other.png": 241,
	"./Twitter.png": 242,
	"./icon.png": 56,
	"./landing2.png": 94,
	"./wave.png": 243,
	"./wave1.png": 244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;